import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListSellersParams } from 'src/app/core/sellers.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  NAME_LABEL,
  SELLER_ID_LABEL,
  PHONE_VALUE_LABEL,
  EMAIL_LABEL,
  IS_CONFIRMED_LABEL,
  CONFIRMED_RED_LABEL,
  CONFIRMED_ORANGE_LABEL,
  CONFIRMED_GREEN_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-sellers-filters',
  templateUrl: './sellers-filters.component.html',
  styleUrls: ['./sellers-filters.component.scss'],
})
export class SellersFiltersComponent {
  @Input() filters?: ListSellersParams;
  @Output() filter_clear: EventEmitter<ListSellersParams> = new EventEmitter<ListSellersParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }
    return [];
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    switch (key) {
      case 'seller_id':
        return SELLER_ID_LABEL;

      case 'seller_name':
        return NAME_LABEL;

      case 'phone_value':
        return PHONE_VALUE_LABEL;

      case 'email':
        return EMAIL_LABEL;

      case 'is_confirmed':
        return IS_CONFIRMED_LABEL;

      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'seller_id':
        return this.filters?.seller_id || '-';

      case 'seller_name':
        return this.filters?.seller_name || '-';

      case 'phone_value':
        return this.filters?.phone_value || '-';

      case 'email':
        return this.filters?.email || '-';

      case 'is_confirmed':
        switch (this.filters?.is_confirmed) {
          case 'red':
            return CONFIRMED_RED_LABEL;
          case 'orange':
            return CONFIRMED_ORANGE_LABEL;
          case 'green':
            return CONFIRMED_GREEN_LABEL;
          default:
            return '-';
        }

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
